/**************************************************
 * Nombre:       Locales_VerCatalogo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {PictureAsPdf} from '@mui/icons-material'
import {irUrl} from "../../../Utilidades/irUrl";
import {LINKMENU} from "../../../Constantes";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Locales_VerCatalogo = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Typography
                        sx={{fontSize: 18, fontWeight: 500, lineHeight: 1.2, textAlign: sCell ? 'center' : 'left'}}>
                        Desde un desayuno energético hasta una cena llena de sabor, en Quesuditas encuentras el plato
                        perfecto:
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}
                      sx={{justifyContent: sCell ? 'center' : 'flex-end', mt: sCell ? 3 : 0}}>
                    <Button
                        onClick={() => irUrl(LINKMENU)}
                        variant={'outlined'} sx={{letterSpacing: 1,}} endIcon={<PictureAsPdf/>}>Descargar
                        Catalogo</Button>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Locales_VerCatalogo